"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJson = void 0;
const fetchHelp_1 = require("./fetchHelp");
function getJson(url, ...keyValues) {
    return fetch(url + (0, fetchHelp_1.getUrlQuery)(keyValues), {
        headers: {
            'Accept': 'application/json'
        }
    })
        .then(fetchHelp_1.checkStatus)
        .then(response => response.json());
}
exports.getJson = getJson;
